import { Line } from './line.model';
import { ReelWinPosition } from './reel-position.model';
import { SpecialSymbolGroup } from './special-symbol-group.model';

export class CollapseGroup {
  public newReels: number[];
  public positions: number[];
  public winLines: Line[];
  public type: string;
  public multiplier: number;
  public roundWin: number;
  public winPositions: ReelWinPosition[];
  public viewReels: number[][];
  public specialSymbolGroups: SpecialSymbolGroup[];

  public get totalWin(): number {
    return this.roundWin * this.multiplier;
  }
}

export class CollapseInfo {
  public collapsingCounter = 0;
  public groups: CollapseGroup[];

  public nextRound(): void {
    this.collapsingCounter++;
  }

  public get currentRound(): CollapseGroup | null {
    return this.groups[this.collapsingCounter] || null;
  }

  public get lastGroup(): CollapseGroup | null {
    return this.groups.length > 0 ? this.groups[this.groups.length - 1] : null;
  }
}
